// extracted by mini-css-extract-plugin
export default {"add_button":"userManagement_add_button__rCjy3","input":"userManagement_input__IUwDq"};